
const digest = '57f36291af04a6c90f4a7f2560d2f1f8566bcaece65716e279f25cc41a8e6487';
const css = `._commandMenuItemIcon_1qab6_1 {
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItemIcon":"_commandMenuItemIcon_1qab6_1"};
export { css, digest };
  